import { TypographyOptions } from '@mui/material/styles/createTypography';

import { Colors } from '@/assets';

export default function themeTypography(): TypographyOptions {
    return {
        h1: {
            fontWeight: 900,
            color: Colors.cloudBurstBlue,
            fontSize: '3rem',
            lineHeight: '3.8rem'
        },
        h2: {
            fontWeight: 800,
            color: Colors.cloudBurstBlue,
            fontSize: '2.2rem',
            lineHeight: '2.8rem'
        },
        h3: {
            fontWeight: 800,
            color: Colors.cloudBurstBlue,
            fontSize: '2rem',
            lineHeight: '2.5rem'
        },
        h4: {
            fontWeight: 800,
            color: Colors.cloudBurstBlue,
            fontSize: '1.8rem',
            lineHeight: '2.3rem'
        },
        h5: {
            fontWeight: 800,
            color: Colors.cloudBurstBlue,
            fontSize: '1.7rem',
            lineHeight: '2.1rem'
        },
        h6: {
            fontWeight: 700,
            color: Colors.cloudBurstBlue,
            fontSize: '1.6rem',
            lineHeight: '2rem'
        },
        caption: {
            fontSize: '1.5rem',
            fontWeight: 500,
            lineHeight: '1.9rem',
            color: Colors.cloudBurstBlue
        },
        subtitle1: {
            fontSize: '1.4rem',
            fontWeight: 400,
            lineHeight: '1.7rem',
            color: Colors.cloudBurstBlue
        },
        subtitle2: {
            fontSize: '1.3rem',
            fontWeight: 400,
            lineHeight: '1.6rem',
            color: Colors.cloudBurstBlue
        },
        body1: {
            fontSize: '1.2rem',
            fontWeight: 400,
            lineHeight: '1.5rem',
            color: Colors.cloudBurstBlue
        },
        body2: {
            fontSize: '1.1rem',
            fontWeight: 400,
            lineHeight: '1.4rem',
            color: Colors.cloudBurstBlue
        },
        button: {
            textTransform: 'capitalize',
            fontWeight: 500,
            fontSize: '1.5rem',
            lineHeight: '1.9rem'
        }
    };
}
